// ============================================================
//  Miller & Miller Services LLC - Mock data (frontend-first)
//  All content mirrors millermillerservices.com (Melbourne, FL)
// ============================================================

export const COMPANY = {
  name: "Miller & Miller Services LLC",
  short: "Miller & Miller",
  tagline: "Family-Owned Screen & Pool Enclosure Specialists",
  phone: "321-608-0255",
  phoneHref: "tel:+13216080255",
  smsHref: "sms:+13216080255",
  email: "info@millermillerservices.com",
  address: "177 Lynn Ave, Melbourne, FL 32935",
  serviceArea: "Melbourne, FL & the Space Coast",
  hours: "Mon-Fri: 8:00AM-5:00PM",
  logo: "https://customer-assets-0z36b82j.emergentagent.net/job_miller-wcag-mobile/artifacts/ha45ga4p_millermiller.png.webp",
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61583948331274",
    instagram: "https://www.instagram.com/millermillerservices177/",
    googleMaps: "https://share.google/AyVGzO0kiiie0CysI",
  },
};

export const ASSETS = {
  heroVideo:
    "https://customer-assets-0z36b82j.emergentagent.net/job_miller-wcag-mobile/artifacts/val56ghq_1099331985-preview.mp4",
  heroVideoAlt: "/videos/mm-vertical.mp4",
  heroVideoReal: "/videos/mm-hero.mp4",
  pool1: "/photos/stock-1.jpg",
  pool2: "/photos/stock-2.jpg",
  pool3: "/photos/mm-16.jpg",
  about: "/photos/mm-04.jpg",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services", dropdown: true },
  { label: "Gallery", to: "/gallery" },
  { label: "Financing", to: "/financing" },
  { label: "FAQs", to: "/faqs" },
  { label: "Contact", to: "/contact" },
];

export const TRUST_BADGES = [
  "Licensed & Insured",
  "Free Estimates",
  "Lifetime Manufacturing Warranty",
  "Family-Owned",
  "5-Star Reviewed",
];

export const HERO = {
  eyebrow: "Space Coast's #1 Trusted!",
  title: "Creating Luxurious Retreats In Your Backyard",
  subtitle:
    "Custom screen enclosures, pool enclosures & outdoor upgrades built for comfort, beauty, and long-lasting protection - enjoy your home the way it was meant to be.",
};

export const SERVICES = [
  {
    id: "pool-enclosures",
    title: "Pool Screen Enclosures",
    tag: "Most Popular",
    short:
      "Enjoy a cleaner, cozier, more private pool with professionally manufactured mesh that keeps out insects, debris & harsh weather.",
    long:
      "Create a beautiful, secure outdoor space ideal for leisure and entertainment. Our premium pool enclosures enhance appearance, keep pests out, and allow cool air to flow - custom-engineered for Florida's climate.",
    image: ASSETS.pool1,
    features: ["Insect & debris protection", "Custom architectural styles", "Storm-rated aluminum framing"],
  },
  {
    id: "patio-porch",
    title: "Patio & Porch Enclosures",
    tag: "",
    short:
      "Durable, low-maintenance patio covers and screened porches that add shade, elegance, and valuable living space.",
    long:
      "Enjoy fresh air, shade, and a bug-free atmosphere right outside your door. Our patio and porch enclosures expand your usable living space with increased privacy, UV protection, and insect defense.",
    image: "/photos/mm-23.jpg",
    features: ["UV & sun protection", "Adds usable living space", "Privacy & bug-free comfort"],
  },
  {
    id: "lanai-porch-screening",
    title: "Lanai & Porch Screening",
    tag: "",
    short:
      "Screen an existing covered porch or lanai to keep out insects and debris while maintaining airflow and visibility.",
    long:
      "Transform an existing covered porch or lanai into a more comfortable, usable outdoor space. We can professionally screen existing openings to help keep out insects and debris while maintaining airflow and visibility.",
    image: "/photos/mm-11.jpg",
    features: ["Screen existing openings", "Keeps out insects & debris", "Maintains airflow & visibility"],
  },
  {
    id: "rescreen-repair",
    title: "Rescreening & Screen Repair",
    tag: "Fast Turnaround",
    short:
      "Fast, reliable repair services that restore the appearance, function & safety of existing enclosures - like new again.",
    long:
      "We fix damaged screens, tighten frames, and refresh your space so it functions and looks brand new. Expect greater durability, improved visibility, and added security - most repairs done quickly.",
    image: "/photos/mm-15.jpg",
    features: ["Tear & tension repairs", "Frame tightening", "Full rescreens"],
  },
  {
    id: "carports",
    title: "Carports",
    tag: "",
    short:
      "Long-lasting carports that protect vehicles from sun, rain, and weather while providing ample ventilation.",
    long:
      "Protect your vehicles from the sun, rain, and bad weather with durable carports offering weather resistance, structural longevity, and custom size options.",
    image: "/photos/carport.jpg",
    features: ["Weather resistance", "Structural longevity", "Custom sizing"],
  },
  {
    id: "lanai-elite",
    title: "Lanai & Elite Enclosures",
    tag: "",
    short:
      "Customizable elite & lanai enclosures that balance indoor comfort with outdoor openness and beauty.",
    long:
      "Our Lanai and Elite screen enclosures ensure indoor comfort and outdoor openness - making your house feel bigger while protecting against insects, sun, rain, and debris.",
    image: "/photos/lanai-elite.jpg",
    features: ["Indoor comfort feel", "Insect & weather defense", "Fully customizable"],
  },
];

export const WHY_US = [
  {
    icon: "Factory",
    title: "Unique Manufacturing",
    text: "We manufacture top-quality products that are durable, beautiful, and built to resist harsh coastal climate.",
  },
  {
    icon: "PencilRuler",
    title: "Customized Designs",
    text: "Custom design consultations tuned to your needs, preferences, and budget - solutions that fit your space perfectly.",
  },
  {
    icon: "Sparkles",
    title: "Clean & On-Time",
    text: "We work with professionalism and respect - clean job sites, clear communication, and deadlines we meet.",
  },
  {
    icon: "ShieldCheck",
    title: "Warranty Protected",
    text: "Craftsmanship and materials are protected under warranty, including lifetime manufacturing coverage.",
  },
];

export const STEPS = [
  { n: "01", title: "Free Consultation", text: "Tell us about your space. We visit, measure, and listen to exactly what you want." },
  { n: "02", title: "Custom Design", text: "We craft a design tailored to your home, budget, and Florida's weather demands." },
  { n: "03", title: "Precision Build", text: "Our licensed crew installs with premium materials - clean, fast, and on schedule." },
  { n: "04", title: "Enjoy & Relax", text: "Step into your new outdoor retreat, backed by our lifetime manufacturing warranty." },
];

export const GALLERY = [
  { src: "/photos/stock-2.jpg", cat: "Pool Enclosures", title: "Covered Lanai Pool Retreat" },
  { src: "/photos/stock-1.jpg", cat: "Pool Enclosures", title: "Sunlit Screened Pool" },
  { src: "/photos/ow-8.jpg", cat: "Pool Enclosures", title: "Gable Pool Enclosure" },
  { src: "/photos/ow-1.jpg", cat: "Pool Enclosures", title: "Backyard Pool Cage" },
  { src: "/photos/mm-02.jpg", cat: "Pool Enclosures", title: "Screened Pool with Paver Deck" },
  { src: "/photos/mm-03.jpg", cat: "Pool Enclosures", title: "Gable Pool Enclosure" },
  { src: "/photos/mm-04.jpg", cat: "Pool Enclosures", title: "Poolside Screen Retreat" },
  { src: "/photos/mm-17.jpg", cat: "Pool Enclosures", title: "Brick Deck Pool Cage" },
  { src: "/photos/mm-01.jpg", cat: "Pool Enclosures", title: "Lakeside Pool Enclosure" },
  { src: "/photos/mm-05.jpg", cat: "Pool Enclosures", title: "Waterfront Pool Cage" },
  { src: "/photos/mm-15.jpg", cat: "Pool Enclosures", title: "Panoramic Pool Enclosure" },
  { src: "/photos/mm-16.jpg", cat: "Pool Enclosures", title: "Mansard Pool Cage" },
  { src: "/photos/mm-19.jpg", cat: "Pool Enclosures", title: "Backyard Screen Room" },
  { src: "/photos/mm-20.jpg", cat: "Pool Enclosures", title: "Custom Pool Cage" },
  { src: "/photos/mm-21.jpg", cat: "Pool Enclosures", title: "Screened Pool Enclosure" },
  { src: "/photos/ow-5.jpg", cat: "Lanai & Elite", title: "Spacious Screened Lanai" },
  { src: "/photos/mm-06.jpg", cat: "Lanai & Elite", title: "Arched Lanai Enclosure" },
  { src: "/photos/mm-07.jpg", cat: "Lanai & Elite", title: "Elite Arched Screen Room" },
  { src: "/photos/mm-08.jpg", cat: "Lanai & Elite", title: "Grand Arched Enclosure" },
  { src: "/photos/mm-25.jpg", cat: "Lanai & Elite", title: "Elite Screen Lanai" },
  { src: "/photos/mm-26.jpg", cat: "Lanai & Elite", title: "Arched Elite Enclosure" },
  { src: "/photos/mm-22.jpg", cat: "Lanai & Elite", title: "Classic Arched Lanai" },
  { src: "/photos/mm-23.jpg", cat: "Patio & Porch", title: "Screened Patio Enclosure" },
  { src: "/photos/mm-24.jpg", cat: "Patio & Porch", title: "Modern Patio Screen" },
  { src: "/photos/mm-12.jpg", cat: "Patio & Porch", title: "White-Frame Patio Screen" },
  { src: "/photos/mm-13.jpg", cat: "Patio & Porch", title: "Rear Patio Enclosure" },
  { src: "/photos/mm-11.jpg", cat: "Patio & Porch", title: "Screened Back Porch" },
  { src: "/photos/mm-10.jpg", cat: "Patio & Porch", title: "Covered Patio Screen" },
  { src: "/photos/mm-09.jpg", cat: "Patio & Porch", title: "Covered Porch" },
  { src: "/photos/mm-27.jpg", cat: "Patio & Porch", title: "Screened Porch" },
  { src: "/photos/mm-28.jpg", cat: "Patio & Porch", title: "Dusk Porch Screening" },
  { src: "/photos/mm-14.jpg", cat: "Rescreen & Repair", title: "Screen Door Detail" },
  { src: "/photos/mm-18.jpg", cat: "Rescreen & Repair", title: "New Enclosure Prep" },
  { src: "/photos/ow-3.jpg", cat: "Rescreen & Repair", title: "Enclosure Restoration" },
];

export const GALLERY_CATS = [
  "All",
  "Pool Enclosures",
  "Patio & Porch",
  "Lanai & Elite",
  "Rescreen & Repair",
];

export const TESTIMONIALS = [
  {
    quote:
      "Impressive efforts and outstanding detailing. The crew exceeded our expectations by delivering a stunning enclosure on time and with consideration for our personal space.",
    name: "Linda Matthews",
    city: "West Melbourne, FL",
    rating: 5,
  },
  {
    quote:
      "The team visited and our enclosure was rescreened in just one day - the results were impeccable! Impressed by the honest, reliable, and quality work. Highly recommended!",
    name: "Michelle R.",
    city: "Palm Bay, FL",
    rating: 5,
  },
  {
    quote:
      "A great experience throughout. The team was professional, clean, and on time. They delivered exactly what they promised and made the whole process effortless.",
    name: "James Porter",
    city: "Melbourne, FL",
    rating: 5,
  },
  {
    quote:
      "Miller & Miller completely transformed our outdoor space with precision and care. Their customer service and attention to detail were simply outstanding.",
    name: "Emily Carter",
    city: "Viera, FL",
    rating: 5,
  },
];

export const STATS = [
  { value: "500+", label: "Projects Completed" },
  { value: "100%", label: "Satisfaction Focus" },
  { value: "Lifetime", label: "Manufacturing Warranty" },
  { value: "5.0", label: "Average Rating" },
];

export const FAQS = [
  { q: "How long does it take to install?", a: "Almost all of our projects - depending on size and style - are finished in a maximum of 3 to 4 days." },
  { q: "Do you offer any kind of warranty?", a: "Yes, warranties are included with all screens and structures, including lifetime manufacturing coverage." },
  { q: "Can I alter the design as per my requirement?", a: "Absolutely. Each enclosure is custom-made to match your choice and the layout of your home." },
  { q: "Which areas do you cover?", a: "We proudly assist homeowners across Melbourne, FL and the surrounding Space Coast." },
  { q: "Are estimates really free?", a: "Yes! Every estimate is fast, free, and no-obligation. We'll design a plan tailored to your budget." },
];

export const SERVICE_OPTIONS = [
  "Pool Screen Enclosure",
  "Patio / Porch Enclosure",
  "Rescreen / Screen Repair",
  "Carport",
  "Lanai / Elite Enclosure",
  "Not sure - need advice",
];

// Financing (Synchrony)
export const FINANCING = {
  provider: "Synchrony",
  applyUrl: "https://www.synchrony.com/mmc/HQ245171700",
  headline: "Flexible Financing For Your Backyard Transformation",
  intro:
    "A new pool cage installation or a large structural patio build is a major home investment. To help make your backyard transformation affordable, we offer flexible consumer financing through Synchrony with competitive terms and convenient monthly payments.",
  perks: [
    { icon: "CreditCard", title: "Easy Online Application", text: "Apply securely through our Synchrony financing portal in minutes - no paperwork required." },
    { icon: "Percent", title: "Competitive Terms", text: "Enjoy flexible plans and competitive rates designed to fit your budget and project size." },
    { icon: "CalendarClock", title: "Convenient Monthly Payments", text: "Spread the cost of your enclosure over time so you can enjoy your space sooner." },
    { icon: "ShieldCheck", title: "Trusted Lending Partner", text: "Financing is provided by Synchrony, one of the nation's leading consumer finance companies." },
  ],
  steps: [
    { n: "01", title: "Apply Online", text: "Click 'Apply Now' to open our secure Synchrony application and see what you qualify for." },
    { n: "02", title: "Get a Decision", text: "Receive a fast credit decision so you know your budget before we begin." },
    { n: "03", title: "Book Your Estimate", text: "Schedule your free on-site estimate and finalize your custom design." },
    { n: "04", title: "Enjoy Your Space", text: "We build your enclosure while you pay over time with easy monthly payments." },
  ],
  disclaimer:
    "Subject to credit approval. Financing provided by Synchrony Bank. Miller & Miller Services LLC is not a lender. Terms, rates, and promotional offers are determined by Synchrony. Ask us during your on-site estimate for full details.",
};

// Full FAQ content (from millermillerservices.com/faqs)
export const FAQS_FULL = [
  {
    q: "What areas in Brevard County do you serve?",
    blocks: [
      { p: "We proudly design, build, and install custom screen structures across the Florida Space Coast, with a heavy focus on Melbourne, Palm Bay, Viera, Viera West, and Rockledge. Because we are a local, family-owned father-and-son team, we live and work in the same neighborhoods we serve, ensuring every installation meets strict local coastal building codes." },
    ],
  },
  {
    q: 'What is the benefit of installing a custom pool screen enclosure or "pool cage"?',
    blocks: [
      { p: "A custom aluminum pool screen enclosure (often called a pool cage) does far more than just keep out fallen leaves and organic debris. It serves as a structural shield that:" },
      { ul: [
        "Dramatically reduces pool maintenance costs and chemical usage.",
        "Keeps frogs, snakes, and wasps out of your swimming area.",
        "Provides a built-in layer of UV protection from the harsh Florida sun.",
        "Blocks tiny biting insects when built with high-density mesh.",
      ] },
    ],
  },
  {
    q: "What makes your pool cages and patio enclosures more durable than standard builders?",
    blocks: [
      { p: "Most corporate volume builders use cheap materials to maximize their speed. At Miller & Miller Services LLC, we build every structure to withstand severe coastal weather:" },
      { ul: [
        "Stainless Steel Fasteners: We use premium, corrosion-resistant fasteners as our standard to prevent the rust-bleeding that structurally weakens standard enclosures.",
        "20/20 No-See-Um Mesh: Standard mesh lets tiny gnats and midges through. Our high-density weave stops even the smallest Florida pests.",
        "Direct Accountability: Bob and Cole personally build your structure - no third-party subcontractors.",
      ] },
    ],
  },
  {
    q: "Will third-party subcontractors be working on my property?",
    blocks: [
      { p: "Absolutely not. One of the biggest complaints homeowners have with large Brevard County screen enclosure companies is that they sell the job and then outsource the labor to random, cheap sub-crews. When you hire us, you get Bob and Cole on-site. We handle the design, engineering, and physical construction ourselves to guarantee a flawless finish." },
    ],
  },
  {
    q: "Do you offer screen repair and re-screening services?",
    blocks: [
      { p: "Yes, we offer professional re-screening and screen repair services - but we specialize in full structural re-screening and cage restorations rather than minor, single-panel repairs. If your pool cage or patio screen enclosure has loose, saggy mesh, rusted hardware, or storm damage, we can completely replace the screen panels and upgrade your fasteners to restore its structural integrity." },
    ],
  },
  {
    q: 'What is a "screen fill extension" and when do I need one?',
    blocks: [
      { p: "If you are pouring a new concrete pad to extend your outdoor living area, a screen fill extension is the process of structurally extending your existing aluminum lanai or patio cage to cover the new layout. We custom-engineer these extensions to blend seamlessly with your home's original roofline and existing enclosure." },
    ],
  },
  {
    q: 'What is an "Elite Room" and how is it different from a standard screen porch?',
    blocks: [
      { p: "An Elite Room is a premium patio enclosure built using insulated composite roof panels structurally engineered to walk on. Unlike a standard open-air screen porch, an Elite Room provides complete thermal shade, protecting you from both rain and radiant heat, making it the perfect middle ground between a screened lanai and a full sunroom addition." },
    ],
  },
  {
    q: "Do you handle the building permits and HOA approvals for new pool cage installations?",
    blocks: [
      { p: "Yes. Navigating the permitting process in cities like Melbourne and Palm Bay, as well as dealing with strict HOA design guidelines in Viera West, can be a massive headache for homeowners. We take care of the entire municipal permitting and engineering submittal process from start to finish so you don't have to lift a finger." },
    ],
  },
  {
    q: "How are your patio screen enclosures engineered for Florida hurricane season?",
    blocks: [
      { p: "Every aluminum frame we construct is engineered to meet or exceed the wind-load requirements of the Florida Building Code. By utilizing heavier aluminum extruded beams, proper gusset plate reinforcing, and heavy-duty concrete anchor tie-downs, we build patios and pool cages specifically designed to withstand high-velocity hurricane winds." },
    ],
  },
  {
    q: "Do you offer financing options for new screen enclosures?",
    blocks: [
      { p: "Yes! We understand that a new pool cage installation or a large structural patio build is a major home investment. To help make your backyard transformation affordable, we offer flexible consumer financing options with competitive terms. Reach out to us during your on-site estimate to discuss how we can structure your payments." },
    ],
  },
];

// Accessibility statement (from client-provided document)
export const ACCESSIBILITY_STATEMENT = {
  updated: "February 27, 2026",
  sections: [
    {
      heading: "Our Commitment to Accessibility",
      body: [
        "We are committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone and applying relevant accessibility standards to enhance usability and inclusivity.",
        "Our goal is to provide a website that is accessible to the widest possible audience, regardless of technology or ability.",
      ],
    },
    {
      heading: "Accessibility Standards",
      body: [
        "We strive to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA, which are widely recognized as the industry standard for website accessibility.",
        "Accessibility is an ongoing process, and we are actively working toward improving the accessibility and usability of our website.",
      ],
    },
    {
      heading: "Accessibility Technology & Tools",
      body: [
        "To support our accessibility efforts, we have deployed industry-standard accessibility technology designed to enhance usability and assist visitors with disabilities. These tools may provide features such as:",
      ],
      list: [
        "Screen reader enhancements",
        "Keyboard navigation improvements",
        "Color contrast adjustments",
        "Text size and spacing controls",
        "Focus indicators",
        "Additional accessibility interface options",
      ],
      after: [
        "This technology helps us improve accessibility while we continue broader auditing, remediation, and development efforts.",
      ],
    },
    {
      heading: "Ongoing Improvement",
      body: ["Accessibility is an ongoing initiative. We are:"],
      list: [
        "Reviewing site content and functionality regularly",
        "Working with developers and accessibility tools",
        "Identifying and remediating barriers",
        "Incorporating accessibility into future design and development",
      ],
      after: [
        "We understand accessibility is a continuous journey and are committed to making improvements over time.",
      ],
    },
    {
      heading: "Third-Party Content",
      body: [
        "Some areas of the website may include third-party content, plugins, or integrations that are not fully controlled by us.",
        "While we encourage vendors to provide accessible content, we cannot guarantee accessibility of third-party features. However, we welcome feedback regarding any issues encountered.",
      ],
    },
    {
      heading: "Feedback & Assistance",
      body: [
        "If you experience difficulty accessing any part of this website, need assistance, or would like to request content in an alternative format, please contact us. Please include:",
      ],
      list: ["The page URL", "Description of the issue", "Your preferred contact method"],
      after: [
        "Contact information is available on our Contact Us page. We aim to respond within a reasonable timeframe and will make reasonable efforts to provide accessible alternatives.",
      ],
    },
    {
      heading: "Good Faith Efforts",
      body: [
        "We are making good-faith efforts to comply with accessibility standards and improve usability for individuals with disabilities. Despite our efforts, some content may not yet fully meet the strictest accessibility standards due to the evolving nature of technology and ongoing updates.",
        "We appreciate your understanding as we continue improving accessibility.",
      ],
    },
    {
      heading: "Terms & Conditions - Accessibility Clause",
      body: [
        "We are committed to providing an accessible website experience for all users and strive to follow recognized accessibility standards, including WCAG guidelines.",
        "We have implemented industry-standard accessibility tools and continue to review, update, and improve our website to enhance accessibility. Because accessibility is an ongoing process, some areas of the website may not yet fully conform to all accessibility standards.",
        "If you encounter accessibility barriers, please contact us so we can provide assistance, offer alternative access, and address the issue where feasible. Nothing in these Terms is intended to limit any rights available under applicable accessibility laws.",
      ],
    },
  ],
};

// Privacy Policy (SMS-compliant, per carrier requirements)
export const PRIVACY_POLICY = {
  updated: "June 2026",
  intro:
    "This Privacy Policy explains how Miller & Miller Services LLC collects, uses, and protects your personal information, including information related to SMS/text messaging.",
  sections: [
    {
      heading: "1. Data Collection",
      body: [
        "Our organization diligently collects personal information, including but not limited to name, email address, and phone number, upon registration for our comprehensive range of services. Additionally, we may gather detailed usage data and specific device information to enhance and optimize our service offerings, ensuring a tailored and efficient user experience.",
      ],
    },
    {
      heading: "2. Data Usage",
      body: [
        "The information provided is meticulously utilized to deliver and continuously improve our services, tailor your experience to your unique preferences and needs, and communicate pertinent updates or promotional offers that may be of interest to you. This data-driven approach allows us to provide a more personalized and relevant service to our valued users.",
        "Mobile information will not be shared with third parties/affiliates for marketing/promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.",
      ],
    },
    {
      heading: "3. User Rights",
      body: [
        "You are entitled to access, rectify, or delete your personal data at any time. To exercise these fundamental rights, please contact our dedicated privacy team through the appropriate channels provided. We are committed to responding promptly and efficiently to all user requests regarding their personal data.",
      ],
    },
    {
      heading: "4. Opt-In and Opt-Out",
      body: [
        "You retain the option to opt-in or opt-out of marketing communications at any time via your account settings or by directly contacting our support team. We respect your preferences and will promptly update your communication settings according to your wishes.",
      ],
    },
    {
      heading: "5. Contact Information",
      body: [
        "For any privacy-related inquiries or concerns, please do not hesitate to email our dedicated privacy team at info@millermillerservices.com or call at 321-608-0255. Our knowledgeable staff is available to assist you with any questions or issues you may have regarding your personal data and privacy.",
      ],
    },
    {
      heading: "6. Policy Updates",
      body: [
        "We will inform you of any substantial changes to this policy through email or our official website. It is recommended that you periodically review this policy to stay informed about how we protect your personal information and respect your privacy rights.",
      ],
    },
  ],
};

// SMS Terms & Conditions (per carrier requirements)
export const SMS_TERMS = {
  updated: "June 2026",
  intro:
    "These SMS Terms & Conditions govern text message communications between Miller & Miller Services LLC and its customers.",
  sections: [
    {
      heading: "1. SMS Consent Communication",
      body: [
        "The information (Phone Numbers) obtained as part of the SMS consent process will not be shared with third parties for marketing purposes.",
      ],
    },
    {
      heading: "2. Types of SMS Communications",
      body: [
        "If you have consented to receive text messages from Miller & Miller Services LLC, you may receive messages related to the following:",
      ],
      list: ["Estimate scheduling", "Appointment reminders", "Service updates", "Follow-up messages"],
    },
    {
      heading: "3. Message Frequency",
      body: [
        "Message frequency may vary. You may receive up to 10 SMS messages per week regarding your appointments, estimates, or account status.",
      ],
    },
    {
      heading: "4. Potential Fees for SMS Messaging",
      body: [
        "Please note that standard message and data rates may apply, depending on your carrier's pricing plan. These fees may vary if the message is sent domestically or internationally.",
      ],
    },
    {
      heading: "5. Opt-In Method",
      body: ["You may opt in to receive SMS messages from Miller & Miller Services LLC in the following ways:"],
      list: [
        "By submitting an online form.",
        "By providing verbal consent during a recorded or documented telephone call or in-person meeting.",
      ],
    },
    {
      heading: "6. Opt-Out Method",
      body: [
        'You can opt out of receiving SMS messages at any time. To do so, simply reply "STOP" to any SMS message you receive. Alternatively, you can contact us directly to request removal from our messaging list.',
      ],
    },
    {
      heading: "7. Help",
      body: [
        "If you are experiencing any issues, you can reply with the keyword HELP. Or, you can get help directly from us at 321-608-0255.",
      ],
    },
    {
      heading: "8. Standard Messaging Disclosures",
      list: [
        "Message and data rates may apply.",
        'You can opt out at any time by texting "STOP."',
        'For assistance, text "HELP" or visit our Privacy Policy and Terms & Conditions pages.',
        "Message frequency may vary.",
      ],
    },
  ],
};
